var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex align-items-center justify-content-center flex-column"},[_c('img',{attrs:{"src":require("mlearn/icons/loading.svg"),"alt":"Loading...","width":"80px"}}),_vm._v("\n  Đang đăng nhập ...\n")])
}]

export { render, staticRenderFns }